import { render, staticRenderFns } from "./page-insights.vue?vue&type=template&id=56597bb4"
import script from "./page-insights.vue?vue&type=script&lang=js"
export * from "./page-insights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports